export default "__VITE_ASSET__BQEpTFUW__"